import { IContentHubClient } from "../../clients/content-hub-client";
import Guard from "../../guard";
import { IIdIterator } from "./id-iterator";
import { IIdQueryResult } from "./id-query-result";
import { SkipTakeIteratorBase } from "./skip-take-iterator-base";

export class EntityDefinitionIdIterator extends SkipTakeIteratorBase<IIdQueryResult> implements IIdIterator {
    private readonly _client: IContentHubClient;

    constructor(client: IContentHubClient, param: number | IIdQueryResult) {
        super(param);

        Guard.notNullOrUndefined(client);
        this._client = client;
    }

    async getResultAsync(skip: number, take: number): Promise<IIdQueryResult> {
        return await this._client.entityDefinitions.getRangeIdsAsync(skip, take);
    }
}
